import axios from "axios";
import { authSlice, callTypes } from "./authSlice";

export const API_URL = process.env.REACT_APP_API_URL;
const { REACT_APP_SESSION_TIME } = process.env;
const { actions } = authSlice;

export const login = (email, password) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.login }));

  return axios
    .post(API_URL + "auth/local", {
      email: email,
      password: password,
    })
    .then((response) => {
      const { user, jwt } = response.data;

      dispatch(
        actions.loginFetched({
          user: user,
          jwt: jwt,
          expiresIn: Date.now() + parseInt(REACT_APP_SESSION_TIME),
        })
      );
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.login }));
    });
};

export const logout = () => (dispatch) => {
  dispatch(actions.logoutFetched());
};

export const refreshToken = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.refreshToken }));
  dispatch(actions.changeNeedRefresh({ callType: callTypes.refreshToken }));
  return axios
    .get(API_URL + "auth/refresh-token")
    .then((response) => {
      dispatch(
        actions.refreshToken({
          token: response.data.jwt,
          expiresIn: Date.now() + parseInt(REACT_APP_SESSION_TIME),
        })
      );
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.refreshToken })
      );
    });
};

export const validateLoading = (param) => (dispatch) => {
  dispatch(actions.validationLoading());
  return;

};

export const validate = (params) => (dispatch) => {
  console.log("User Data: ", process.env)
  console.log("url", API_URL + "/auth/email-confirmation?code=" + params.code + "&email=" + params.email + "&api_version=1.1")
  return axios
    .get(API_URL + "/auth/email-confirmation?code=" + params.code + "&email=" + params.email, {
      params: {
        api_version: '1.1'
      }
    })
    .then((response) => {
      console.log("User Data response: ", response.data)
      dispatch(actions.validationFetched({}));
    })
    .catch((err) => {
      console.error("Error");
      console.error("Error", err.response.data);
      dispatch(
        actions.validationError({ error: err })
      );
    });
};